/* eslint-disable react/no-unused-prop-types */
/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';

import { mediaPhone } from '../styles/breakpoints';
import { LogoLabelStyles, px, LOGO_PHONE_SCALE } from '../styles/Logo';
import { sharpImageRendering } from '../styles/images';

import LogoImage from './Bundesstiftung-Logo.png';
import LogoImage2x from './Bundesstiftung-Logo@2x.png';

const LOGO_WIDTH = 186;
const LOGO_HEIGHT = 31;

export const BALogoSmallOnPhone = css({
  [mediaPhone]: {
    width: px(LOGO_WIDTH * LOGO_PHONE_SCALE),
    height: px(LOGO_HEIGHT * LOGO_PHONE_SCALE),
    marginTop: '11px',
  },
});

const BALogo = ({ className, labelStyles, imageContainerStyles, imageStyles }) => (
  <article className={className}>
    <div className={css(LogoLabelStyles, labelStyles)}>
      Gefördert von
    </div>
    <div
      className={css({
        textAlign: 'right',
      }, imageContainerStyles)}
    >
      <a href="https://www.bundesstiftung-aufarbeitung.de" target="_blank" rel="noopener nofollow external">
        <img
          src={LogoImage}
          srcSet={`${LogoImage} 1x, ${LogoImage2x} 2x`}
          alt="Bundesstiftung Aufarbeitung"
          className={css(sharpImageRendering, {
            width: px(LOGO_WIDTH),
            height: px(LOGO_HEIGHT),
            marginTop: '7px',
          }, imageStyles)}
        />
      </a>
    </div>
  </article>
);

BALogo.propTypes = {
  className: PropTypes.string,
  labelStyles: PropTypes.any,
  imageContainerStyles: PropTypes.any,
  imageStyles: PropTypes.any,
};

BALogo.defaultProps = {
  className: undefined,
  labelStyles: undefined,
  imageContainerStyles: undefined,
  imageStyles: undefined,
};

export default BALogo;



// WEBPACK FOOTER //
// ./src/components/BALogo/BALogo.js